/**
 * Active-route check for the Dashboard nav entry. The `slug` arrives with and
 * without a leading slash depending on the caller, so it's normalized once here
 * rather than repeating a `=== 'dashboard' || === '/dashboard'` guard at each
 * call site.
 */
export const isDashboardSlug = (slug: string): boolean => slug.replace(/^\/+/, '') === 'dashboard';
